<template>
	<div class="favouriteProduct">
		<div class="sectionHeader ml-[0.375rem] mr-04 flex h-07 items-center gap-02 text-ink-38">
			<div :class="['expandIcon cursor-pointer hover:text-ink-60', { expandIcon__rotated: !isExpanded }]">
				<Icon name="chevron-down" size="1.5" @click="toggleExpandedState" />
			</div>

			<span class="font-paragraph-s flex items-center gap-03 overflow-x-hidden text-ellipsis whitespace-nowrap">
				<FavouriteButton
					:value="
						areAllSKUsMarkedAsFavourite(store.id, name) ? 'added' : areSomeSKUsMarkedAsFavourite(store.id, name) ? 'partially-added' : 'removed'
					"
					@add="addAllSKUsToFavourites(store.id, name)"
					@remove="removeAllSKUsFromFavourites(store.id, name)"
				/>

				<TooltipIfEllipsis :tooltip-text="name">
					{{ name }}
				</TooltipIfEllipsis>
			</span>
		</div>

		<div v-if="isExpanded" class="font-paragraph-s ml-[3.875rem] mr-04 text-ink-87">
			<div v-for="sku in skus" :key="sku.unique_sku_id" class="skuItem flex h-07 items-center gap-03 hover:bg-level-01">
				<FavouriteButton
					:value="temporaryFavouriteSKUIds.has(sku.unique_sku_id) ? 'added' : 'removed'"
					@add="addSKUToFavourites(sku.unique_sku_id)"
					@remove="removeSKUFromFavourites(sku.unique_sku_id)"
				/>

				<span class="overflow-x-hidden text-ellipsis whitespace-nowrap">
					<TooltipIfEllipsis :tooltip-text="sku.human_name">
						{{ sku.human_name }}
					</TooltipIfEllipsis>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Icon, TooltipIfEllipsis } from '@bluebrick/saas-ui'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import FavouriteButton from '@/features/skus/components/FavouriteButton.vue'
import { useSkusStore } from '@/features/skus/useSkusStore'
import { type Product, type Store } from '@/types'

defineProps<{
	name: string
	skus: Product[]
	store: Store
}>()

const { temporaryFavouriteSKUIds } = storeToRefs(useSkusStore())
const {
	addSKUToFavourites,
	removeSKUFromFavourites,
	addAllSKUsToFavourites,
	removeAllSKUsFromFavourites,
	areAllSKUsMarkedAsFavourite,
	areSomeSKUsMarkedAsFavourite
} = useSkusStore()

const isExpanded = ref(true)

function toggleExpandedState() {
	isExpanded.value = !isExpanded.value
}
</script>

<style lang="scss" scoped>
.favouriteProduct {
	.expandIcon {
		transition: all 0.1s linear;

		&__rotated {
			transform: rotate(-90deg);
		}
	}

	.skuItem {
		border-bottom: 1px solid theme('colors.level.03');
	}
}
</style>
